// extracted by mini-css-extract-plugin
export default {"profileEdit":"EditProfile_profileEdit__iCCZ5","header":"EditProfile_header__Gfqa5","btn":"EditProfile_btn__b65wN","errorMessage":"EditProfile_errorMessage__X2Lv7"};